<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g id="Group_2216" data-name="Group 2216" transform="translate(-277 -469)">
    <rect id="Rectangle_186" data-name="Rectangle 186" width="16" height="16" transform="translate(277 469)" fill="none"/>
    <g id="Group_2101" data-name="Group 2101" transform="translate(279.9 482) rotate(-90)">
      <rect id="Rectangle_149" data-name="Rectangle 149" width="10" height="10" transform="translate(0 0.1)" fill="none"/>
      <path id="chevron-down" d="M6,9l4.192,4.192L14.385,9" transform="translate(-5.3 -5.3)" fill="none" stroke="#4563ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
  </g>
</svg>
